<template>
<div>
  <validation-observer ref="obs" v-slot="ObserverProps">
    <b-row>
      <b-col>
        <validation-provider name="date" rules="required">
          <b-form-input v-model="editingRecord.date" :type="'date'"></b-form-input>
        </validation-provider>
      </b-col>
      <b-col>
        <b-form inline style="width:auto">
          <b-form-select v-model="editingRecord.round" :options="roundOptions" class="mb-2 mr-sm-2 mb-sm-0"></b-form-select>
        </b-form>
      </b-col>
    </b-row>
    <b-row class="text-center clear">
      <b-col>
        <b-form-input v-model="editingRecord.player1Name" placeholder="1人目" list="utsusemiUserList1" @update="setUid(1,editingRecord.player1Name)" autocomplete="off"> </b-form-input>
        <datalist id="utsusemiUserList1">
          <option v-for="member in memberNameList" :key="member">{{member}}</option>
        </datalist>
        <b-row class="danRow" v-if="editingRecord.player1Kyu != '' || editingRecord.player1Dan != ''">
          <b-col class="mx-0 px-0 danCol d-flex align-items-center">
            <div class="my-auto align-middle" style="font-size:16px;padding-left:15px">{{editingRecord.player1Kyu}}級{{editingRecord.player1Dan}}段</div>
            <b-badge class="danBadge ml-auto" @click="$bvModal.show('editRankAndDan2');setEditParams(editingRecord.player1Name,'player1')">修正</b-badge>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-form-input v-model="editingRecord.player2Name" placeholder="2人目" list="utsusemiUserList2" @update="setUid(2,editingRecord.player2Name)" autocomplete="off">
        </b-form-input>
        <datalist id="utsusemiUserList2">
          <option v-for="member in memberNameList" :key="member">{{member}}</option>
        </datalist>
        <b-row class="danRow" v-if="editingRecord.player2Kyu != '' || editingRecord.player2Dan != ''">
          <b-col class="mx-0 px-0 danCol d-flex align-items-center">
            <div class="my-auto align-middle" style="font-size:16px;padding-left:15px">{{editingRecord.player2Kyu}}級{{editingRecord.player2Dan}}段</div>
            <b-badge class="danBadge ml-auto" @click="$bvModal.show('editRankAndDan2');setEditParams(editingRecord.player2Name,'player2')">修正</b-badge>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col>
        <b-form-select v-model="editingRecord.player1Result" :options="resultOptions" @input="setResult('player2')" key="input-result"></b-form-select>
      </b-col>
      <b-col>
        <validation-provider name="cardNumber" rules="min_value:1|max_value:48" v-slot="{ errors }">
          <b-form-input v-model="editingRecord.cardNumber" placeholder="枚数" type="number" key="input-result"></b-form-input>
          <p class="error">{{ errors[0] }}</p>
        </validation-provider>
      </b-col>
      <b-col>
        <b-form-select v-model="editingRecord.player2Result" :options="resultOptions" @input="setResult('player1')" key="input-result"></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="練習の分類">
          <b-form-select v-model="editingRecord.practiceType" :options="practiceTypeOptions"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" class="my-2 mx-2 float-right" @click="update()" :disabled="ObserverProps.invalid" size="sm">更新</b-button>
        <b-button variant="outline-danger" class="my-2 mx-2 float-right" @click="$bvModal.show('remove')" size="sm">削除</b-button>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <b-button variant="success" class="my-2 ml-auto mr-2 float-right" v-b-toggle.comment size="sm">コメントを書く</b-button>
      </b-col>
    </b-row>
  </validation-observer>
  <validation-observer ref="obs" v-slot="ObserverProps">
    <b-row>
      <b-col>
        <b-collapse id="comment">
          <b-form-radio-group class="my-1" v-model="commentType" :options="commentTypeOptions"></b-form-radio-group>
          <validation-provider name="comment" rules="required">
            <b-textarea rows="3" v-model="comment"></b-textarea>
          </validation-provider>
          <b-button variant="success" class="my-2 ml-auto mr-2 float-right" size="sm" @click="sendComment()" :disabled="ObserverProps.invalid" v-b-toggle.comment>送信</b-button>
        </b-collapse>
      </b-col>
    </b-row>
  </validation-observer>

  <b-row>
    <b-col>
      <div v-for="(value,key) in this.comments" :key="key">
        <div v-if="value.commentType=='public'">
          <validation-observer ref="obs" v-slot="ObserverProps">
            <b-row>
              <label class="my-auto">{{value.name}}: {{value.unixtime | unixtimeToDate}}</label>
              <div v-if="value.name==userName">
                <b-button variant="success" class="my-0 mx-2" size="sm" v-b-toggle="'editingComment'+key">編集</b-button>
              </div><br>
              <div class="font-weight-bold my-auto">（公開）</div>
            </b-row>
            <p style="white-space: pre-line">{{value.text}}</p>
            <b-collapse :id="'editingComment'+key">
              <validation-provider name="editingComment" rules="required">
                <b-textarea v-model="commentsReplica[key]['text']"></b-textarea>
                <div class="text-right">
                  <b-button variant="outline-danger" class="my-2 mx-2" size="sm" @click="$bvModal.show('removeComment');setRemoveCommentKey(key)">削除</b-button>
                  <b-button variant="success" class="my-2 mx-2" size="sm" @click="updateComment(key)" v-b-toggle="'editingComment'+key" :disabled="ObserverProps.invalid">更新</b-button>
                </div>
              </validation-provider>
            </b-collapse>
            <hr>
          </validation-observer>
        </div>
        <div v-if="value.commentType=='private'&&value.name==userName">
          <validation-observer ref="obs" v-slot="ObserverProps">
            <b-row>
              <label class="my-auto">{{value.name}}: {{value.unixtime | unixtimeToDate}}</label>
              <div v-if="value.name==userName">
                <b-button variant="success" class="my-0 mx-2" size="sm" v-b-toggle="'editingComment'+key">編集</b-button>
              </div><br>
              <div class="font-weight-bold my-auto">（自分のみ）</div>
            </b-row>
            <p style="white-space: pre-line">{{value.text}}</p>
            <b-collapse :id="'editingComment'+key">
              <validation-provider name="editingComment" rules="required">
                <b-textarea v-model="commentsReplica[key]['text']"></b-textarea>
                <div class="text-right">
                  <b-button variant="outline-danger" class="my-2 mx-2" size="sm" @click="$bvModal.show('removeComment');setRemoveCommentKey(key)">削除</b-button>
                  <b-button variant="success" class="my-2 mx-2" size="sm" @click="updateComment(key)" v-b-toggle="'editingComment'+key" :disabled="ObserverProps.invalid">更新</b-button>
                </div>
              </validation-provider>
            </b-collapse>
            <hr>
          </validation-observer>
        </div>
        <div v-if="value.commentType=='seniorMemberOnly'&&userEnterYear<getFiscalYear(value.unixtime)">
          <validation-observer ref="obs" v-slot="ObserverProps">
            <b-row>
              <label class="my-auto">{{value.name}}: {{value.unixtime | unixtimeToDate}}</label>
              <div v-if="value.name==userName">
                <b-button variant="success" class="my-0 mx-2" size="sm" v-b-toggle="'editingComment'+key">編集</b-button>
              </div><br>
              <div class="font-weight-bold my-auto">（上級生のみ）</div>
            </b-row>
            <p style="white-space: pre-line">{{value.text}}</p>
            <b-collapse :id="'editingComment'+key">
              <validation-provider name="editingComment" rules="required">
                <b-textarea v-model="commentsReplica[key]['text']"></b-textarea>
                <div class="text-right">
                  <b-button variant="outline-danger" class="my-2 mx-2" size="sm" @click="$bvModal.show('removeComment');setRemoveCommentKey(key)">削除</b-button>
                  <b-button variant="success" class="my-2 mx-2" size="sm" @click="updateComment(key)" v-b-toggle="'editingComment'+key" :disabled="ObserverProps.invalid">更新</b-button>
                </div>
              </validation-provider>
            </b-collapse>
            <hr>
          </validation-observer>
        </div>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <div v-if="editingRecord.player1Uid!==''" class="text-center">
        <router-link :to="{ name: 'individualRecords',query:{userId:editingRecord.player1Uid,userName:editingRecord.player1Name}}">
          <b-button variant="outline-info" class="my-2 mx-2" size="sm" @click="$bvModal.hide('edit')">{{editingRecord.player1Name}}さんの他の記録を見る</b-button>
        </router-link>
      </div>
    </b-col>
    <b-col>
      <div v-if="editingRecord.player2Uid!==''" class="text-center">
        <router-link :to="{ name: 'individualRecords',query:{userId:editingRecord.player2Uid,userName:editingRecord.player2Name}}">
          <b-button variant="outline-info" class="my-2 mx-2" size="sm" @click="$bvModal.hide('edit')">{{editingRecord.player2Name}}さんの他の記録を見る</b-button>
        </router-link>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-button variant="outline-secondary" class="my-2 mx-auto" size="sm" @click="$bvModal.hide('edit')">閉じる</b-button>
  </b-row>

  <b-modal v-bind:id="'remove'" hide-header hide-footer modal-center>
    <b-row>
      <b-col>
        <label>記録を削除します。よろしいですか？</label>
      </b-col>
    </b-row>
    <b-row class="float-right">
      <b-col>
        <b-button variant="secondary" class="my-2 mx-2" @click="$bvModal.hide('remove')" size="sm">やめる</b-button>
        <b-button variant="outline-danger" class="my-2 mx-2" @click="remove()" size="sm">記録を削除</b-button>
      </b-col>
    </b-row>
  </b-modal>
  <b-modal v-bind:id="'removeComment'" hide-header hide-footer modal-center>
    <b-row>
      <b-col>
        <label>コメントを削除します。よろしいですか？</label>
      </b-col>
    </b-row>
    <b-row class="float-right">
      <b-col>
        <b-button variant="secondary" class="my-2 mx-2" @click="$bvModal.hide('removeComment')" size="sm">やめる</b-button>
        <b-button variant="outline-danger" class="my-2 mx-2" @click="removeComment();$bvModal.hide('removeComment')" size="sm">コメントを削除</b-button>
      </b-col>
    </b-row>
  </b-modal>
  <b-modal v-bind:id="'editRankAndDan2'" hide-header hide-footer modal-center>
    <b-row>
      <b-col>
        <label>{{memberEditParams2.name}}さんの段と級を変更します。</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form inline>
          <b-form-select v-model="memberEditParams2.rank" :options="kyuOptions"></b-form-select>
          <label for="inline-form-input-kyu">級</label>
          <b-form-select v-model="memberEditParams2.dan" :options="danOptions"></b-form-select>
          <label for="inline-form-input-dan">段</label>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" class="my-2 mx-2 float-right" @click="editMeiboMember(memberEditParams2);$bvModal.hide('editRankAndDan2')" size="sm">変更</b-button>
      </b-col>
    </b-row>
  </b-modal>

</div>
</template>
<style>

</style>
<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import {
  ValidationProvider,
  extend
} from "vee-validate";
import {
  required,
  min_value,
  max_value,
} from "vee-validate/dist/rules";
extend('required', required);
extend('min_value', {
  ...min_value,
  message: '枚数は1以上の値を入力してください'
});
extend('max_value', {
  ...max_value,
  message: '枚数は48以下の値を入力してください'
});

export default {
  name: 'record',
  components: {
    ValidationProvider,
  },
  filters: {
    unixtimeToDate: function(unixtime) {
      return dayjs(unixtime * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
  },
  props: ['record'],
  data() {
    return {
      round: "",
      date: "",
      unixtime: "",
      editingRecord: {},
      memberNameList: [],
      memberKanaList: [],
      utsusemiUserList: [],
      meiboHash: {},
      resultOptions: [{
          value: '',
          text: ''
        },
        {
          value: 1,
          text: '勝ち'
        },
        {
          value: 0,
          text: '負け'
        },
        {
          value: -1,
          text: '指導'
        },
      ],
      roundOptions: [{
          value: 1,
          text: '1回戦'
        },
        {
          value: 2,
          text: '2回戦'
        },
        {
          value: 3,
          text: '3回戦'
        },
        {
          value: 4,
          text: '4回戦'
        },
        {
          value: 5,
          text: '5回戦'
        },
        {
          value: 6,
          text: '6回戦'
        },
        {
          value: 7,
          text: '7回戦'
        },
        {
          value: 8,
          text: '8回戦'
        },
        {
          value: 9,
          text: '9回戦'
        },
        {
          value: 10,
          text: '10回戦'
        },
        {
          value: 11,
          text: '11回戦'
        },
      ],
      comment: new String,
      comments: new Object,
      commentsReplica: new Object,
      editingComment: new Object,
      memberEditParams2: {
        "name": "test"
      },
      kyuOptions: [{
        text: "未選択",
        value: ""
      }, "A", "B", "C", "D", "E"],
      danOptions: [{
        text: "未選択",
        value: ""
      }, "10", "9", "8", "7", "6", "5", "4", "3", "2", "初", "無"],
      removeCommentKey: "",
      userName: "",
      userEnterYear: "",
      practiceTypeOptions:[{
        value: 'uncategorized',
        text:'(分類なし)'
      },
      {
        value:'beginner',
        text: '初心者練'
      },
      {
        value:'experienced',
        text: '経験者練'
      },
      ],
      commentType: "public",
      commentTypeOptions: [{
          value: 'public',
          text: '公開'
        },
        {
          value: 'seniorMemberOnly',
          text: '上級生のみ'
        },
        {
          value: 'private',
          text: '自分のみ',
        }
      ],
      fiscalYear: "",
    }
  },
  created: function() {
    this.database = firebase.database()
    this.user = firebase.auth().currentUser;
    var _this = this;
    if (this.round === "") {
      this.round = this.record.round
    }
    if (this.date === "") {
      this.unixtime = -dayjs(this.record.date).unix();
      this.date = this.record.date
    }

    this.editingRecord = JSON.parse(JSON.stringify(this.record));
    this.database = firebase.database();

    this.database.ref('users/' + this.user.uid + '/name').once("value", snapShot => {
      if (snapShot) _this.userName = snapShot.val(); // ログインユーザー名の取得
    })

    this.database.ref('users/' + this.user.uid + '/enterYear').once("value", snapShot => {
      if (snapShot) _this.userEnterYear = snapShot.val(); // ログインユーザーの入会年の取得
    })

    // 空蝉ユーザーの取得
    this.database.ref('users/').on("value", snapShot => {
      if (snapShot) {
        _this.utsusemiUserList = [];
        snapShot.forEach((data) => {
          let user = data.val();
          user['uid'] = data.key;
          _this.utsusemiUserList.push(user);
        });
      }
    })
    _this.meiboHash = this.sortMeibo();
    _this.memberNameList = Object.keys(this.meiboHash)

    // 名簿の取得
    this.database.ref('meibo/').on("value", snapShot => {
      if (snapShot) {
        snapShot.forEach((data) => {
          let meiboMemberByYear = data.val();
          for (let member in meiboMemberByYear) {
            meiboMemberByYear[member]['year'] = data.key
          }
          _this.meiboHash = Object.assign(_this.meiboHash, meiboMemberByYear)
        });
      }
    })
    _this.meiboHash = this.sortMeibo();
    _this.memberNameList = Object.keys(this.meiboHash)

    this.setComment(this.unixtime, this.round); // コメントをセット

    let now = dayjs();
    this.fiscalYear = this.getFiscalYear(now.unix());
    if (this.userEnterYear == this.fiscalYear) {
      this.commentTypeOptions = [{
          value: 'public',
          text: '公開'
        },
        {
          value: 'private',
          text: '自分のみ',
        }
      ]
    }
  },
  methods: {
    setResult(player) {
      //プレイヤー1（2）の勝敗を設定したときに、プレイヤー2（1）の勝敗を設定する
      if (player == "player2") {
        if (this.editingRecord.player1Result === "" || this.editingRecord.player1Result === -1) {
          this.editingRecord.player2Result = this.editingRecord.player1Result;
        } else {
          this.editingRecord.player2Result = 1 - this.editingRecord.player1Result
        }
      } else {
        if (this.editingRecord.player2Result === "" || this.editingRecord.player2Result === -1) {
          this.editingRecord.player1Result = this.editingRecord.player2Result;
        } else {
          this.editingRecord.player1Result = 1 - this.editingRecord.player2Result
        }
      }
    },
    setUid(playerSide, playerName) {

      //アプリ利用者の場合、Uidを設定する
      for (let i = 0, l = this.utsusemiUserList.length; i < l; i++) {
        if (playerName == this.utsusemiUserList[i].name) {
          if (playerSide == 1) {
            this.editingRecord.player1Uid = this.utsusemiUserList[i].uid;
          } else {
            this.editingRecord.player2Uid = this.utsusemiUserList[i].uid;
          }
          break;
        } else {
          if (playerSide == 1) {

            this.editingRecord.player1Uid = "";
          } else {
            this.editingRecord.player2Uid = "";
          }
        }
      }

      if (this.memberNameList.includes(playerName)) {
        if (playerSide == 1) {
          this.editingRecord.player1Kyu = this.meiboHash[playerName].kyu;
          this.editingRecord.player1Dan = this.meiboHash[playerName].dan;
        } else {
          this.editingRecord.player2Kyu = this.meiboHash[playerName].kyu;
          this.editingRecord.player2Dan = this.meiboHash[playerName].dan;
        }
      } else {
        if (playerSide == 1) {
          this.editingRecord.player1Kyu = "";
          this.editingRecord.player1Dan = "";
        } else {
          this.editingRecord.player2Kyu = "";
          this.editingRecord.player2Dan = "";
        }
      }
    },
    update() {
      let round = this.editingRecord.round
      let unixtime = -dayjs(this.editingRecord.date).unix();
      let oldRound = this.round;
      let oldUnixtime = -dayjs(this.date).unix();

      let recordsPostRef = firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"]);
      recordsPostRef.update(this.editingRecord)

      //プレイヤーが変わった場合、変更前のプレイヤーの個人記録を削除する
      if (this.record.player1Uid !== '' && this.editingRecord.player1Uid !== this.record.player1Uid) {
        let oldUserRecordsPostRefForPlayer1 = firebase.database().ref('userRecords/' + this.record.player1Uid + '/' + oldUnixtime + '/' + oldRound + '/' + this.editingRecord["key"]);
        oldUserRecordsPostRefForPlayer1.remove();
      }
      if (this.record.player2Uid !== '' && this.editingRecord.player2Uid !== this.record.player2Uid) {
        let oldUserRecordsPostRefForPlayer2 = firebase.database().ref('userRecords/' + this.record.player2Uid + '/' + oldUnixtime + '/' + oldRound + '/' + this.editingRecord["key"]);
        oldUserRecordsPostRefForPlayer2.remove();
      }

      //プレイヤー1の個人記録の更新
      if (this.editingRecord.player1Uid !== '') {
        let userRecordsPostRefForPlayer1 = firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]);
        let player1Obj = {
          "date": this.editingRecord.date,
          "round": this.editingRecord.round,
          "opponent": this.editingRecord.player2Name,
          "opponentId": this.editingRecord.player2Uid,
          "opponentKyu": this.editingRecord.player2Kyu,
          "opponentDan": this.editingRecord.player2Dan,
          "result": this.editingRecord.player1Result,
          "key": this.editingRecord["key"],
          "cardNumber": this.editingRecord["cardNumber"]
        }
        if (this.editingRecord["comments"]) player1Obj["comments"] = this.editingRecord["comments"]
        userRecordsPostRefForPlayer1.update(player1Obj)
      }

      //プレイヤー2の個人記録の更新
      if (this.editingRecord.player2Uid !== '') {
        let userRecordsPostRefForPlayer2 = firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]);
        let player2Obj = {
          "date": this.editingRecord.date,
          "round": this.editingRecord.round,
          "opponent": this.editingRecord.player1Name,
          "opponentId": this.editingRecord.player1Uid,
          "opponentKyu": this.editingRecord.player1Kyu,
          "opponentDan": this.editingRecord.player1Dan,
          "result": this.editingRecord.player2Result,
          "key": this.editingRecord["key"],
          "cardNumber": this.editingRecord["cardNumber"]
        }
        if (this.editingRecord["comments"]) player2Obj["comments"] = this.editingRecord["comments"]
        userRecordsPostRefForPlayer2.update(player2Obj)
      }

      //日付または回戦が変わった場合、元のデータを削除する
      if (this.editingRecord.round !== this.record.round || this.editingRecord.date !== this.record.date) {
        if (this.editingRecord.player1Uid !== '') {
          let userRecordsPostRefForPlayer1 = firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + oldUnixtime + '/' + oldRound + '/' + this.editingRecord["key"]);
          userRecordsPostRefForPlayer1.remove()
        }
        if (this.editingRecord.player2Uid !== '') {
          let userRecordsPostRefForPlayer2 = firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + oldUnixtime + '/' + oldRound + '/' + this.editingRecord["key"]);
          userRecordsPostRefForPlayer2.remove()
        }
        this.round = this.editingRecord.round
        this.date = this.editingRecord.date
        this.unixtime = -dayjs(this.editingRecord.date).unix();
        let oldRecordsPostRef = firebase.database().ref('records/' + oldUnixtime + '/' + oldRound + '/' + this.editingRecord["key"]);
        oldRecordsPostRef.remove()
      }

      this.$bvModal.hide('edit')
    },
    async remove() {
      let round = this.editingRecord.round
      let unixtime = -dayjs(this.editingRecord.date).unix();
      var recordsPostRef = firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"]);
      await recordsPostRef.remove();
      //userRecordsの更新の処理を書く
      if (this.editingRecord.player1Uid !== '') {
        var userRecordsPostRefForPlayer1 = firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]);
        userRecordsPostRefForPlayer1.remove();
      }
      if (this.editingRecord.player2Uid !== '') {
        var userRecordsPostRefForPlayer2 = firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]);
        userRecordsPostRefForPlayer2.remove();
      }
      //これがrecords/unixtime/round/の下の唯一の記録であれば、placeInfoだけ残ってしまうので消去する
      firebase.database().ref(`records/${unixtime}/${round}`).once("value", snapShot=> {
        console.log(snapShot.val());
        let keys = Object.keys(snapShot.val());
        console.log(keys);
        if(keys.length == 1 && keys[0] == "placeInfo"){console.log("aiu");
          firebase.database().ref(`records/${unixtime}/${round}`).remove();
        }
      })
      this.$bvModal.hide('remove')
      this.$bvModal.hide('edit')
    },
    setComment(unixtime, round) {
      let comments = {};
      firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments').on("value", snapShot => {
        if (snapShot) comments = snapShot.val()
      })
      this.comments = comments;
      this.commentsReplica = JSON.parse(JSON.stringify(this.comments));
    },
    sendComment() {
      let round = this.editingRecord.round
      let unixtime = -dayjs(this.editingRecord.date).unix();
      let comment = {
        text: this.comment,
        unixtime: dayjs().unix(),
        name: this.userName,
        commentType: this.commentType
      }

      // recordsにコメントを投稿し、key(id)を取得
      let commentPostRef = firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments');
      let newCommentPostRef = commentPostRef.push(comment);
      let commentId = newCommentPostRef.key

      // プレイヤー1の個人記録にコメントを投稿
      if (this.editingRecord.player1Uid !== '') {
        let userRecordsPostRefForPlayer1 = firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentId);
        userRecordsPostRefForPlayer1.update(comment)
      }

      // プレイヤー2の個人記録にコメントを投稿
      if (this.editingRecord.player2Uid !== '') {
        let userRecordsPostRefForPlayer2 = firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentId);
        userRecordsPostRefForPlayer2.update(comment)
      }

      this.setComment(unixtime, round)
      this.comment = "";
    },
    setEditingComment(key, value) {
      this.editingComment[key] = value.text;
    },
    updateComment(key) {
      let commentKey = key.replace("comments", "")
      let round = this.editingRecord.round
      let unixtime = -dayjs(this.editingRecord.date).unix();
      let commentUpdateRef = firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentKey);
      let textObject = {
        "text": this.commentsReplica[commentKey]['text']
      };
      commentUpdateRef.update(textObject)

      // プレイヤー1の個人記録にコメントを投稿
      if (this.editingRecord.player1Uid !== '') {
        let player1CommentUpdateRef = firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentKey);
        player1CommentUpdateRef.update(textObject);
      }

      // プレイヤー2の個人記録にコメントを投稿
      if (this.editingRecord.player2Uid !== '') {
        let player2CommentUpdateRef = firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentKey);
        player2CommentUpdateRef.update(textObject);
      }

      this.setComment(unixtime, round)
    },
    setRemoveCommentKey(key) {
      this.removeCommentKey = key;
    },
    removeComment() {
      if (this.removeCommentKey === "") return;
      let commentKey = this.removeCommentKey.replace("comments", "")
      let round = this.editingRecord.round
      let unixtime = -dayjs(this.editingRecord.date).unix();
      let commentRemoveRef = firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentKey);
      commentRemoveRef.remove();
      if (this.editingRecord.player1Uid !== '') {
        let player1CommentRemoveRef = firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentKey);
        player1CommentRemoveRef.remove();
      }
      if (this.editingRecord.player2Uid !== '') {
        let player2CommentRemoveRef = firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"] + '/comments/' + commentKey);
        player2CommentRemoveRef.remove();
      }
      this.setComment(unixtime, round)
    },
    sortMeibo() {
      let meiboArray = new Array();
      for (let person in this.meiboHash) {
        let kana = this.meiboHash[person].kana
        let personObj = {
          "kana": kana,
          "name": person,
          "value": this.meiboHash[person]
        }
        meiboArray.push(personObj)
      }
      meiboArray.sort(function(a, b) {
        if (a.kana < b.kana) {
          return -1;
        } else {
          return 1;
        }
      });
      let meiboObj = new Object();
      for (let i in meiboArray) {
        meiboObj[meiboArray[i].name] = meiboArray[i].value
      }
      return meiboObj;
    },
    setEditParams(name, playerSide) {
      this.memberEditParams2.name = name;
      this.memberEditParams2.rank = this.meiboHash[name].kyu;
      this.memberEditParams2.dan = this.meiboHash[name].dan;
      this.memberEditParams2.year = this.meiboHash[name].year;
      this.memberEditParams2.playerSide = playerSide
    },
    editMeiboMember(memberEditParams2) {
      let kyu = memberEditParams2.rank
      let dan = memberEditParams2.dan
      firebase.database().ref('meibo/' + memberEditParams2['year'] + '/' + memberEditParams2['name']).update({
        "dan": dan
      })
      firebase.database().ref('meibo/' + memberEditParams2['year'] + '/' + memberEditParams2['name']).update({
        "kyu": kyu
      })

      let round = this.editingRecord.round
      let unixtime = -dayjs(this.editingRecord.date).unix();
      if (memberEditParams2.playerSide === 'player1') {
        firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player1Dan": dan
        });
        firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player1Kyu": kyu
        });
        firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player1Dan": dan
        });
        firebase.database().ref('userRecords/' + this.editingRecord.player1Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player1Kyu": kyu
        });
      } else {
        firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player2Dan": dan
        });
        firebase.database().ref('records/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player2Kyu": kyu
        });
        firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player2Dan": dan
        });
        firebase.database().ref('userRecords/' + this.editingRecord.player2Uid + '/' + unixtime + '/' + round + '/' + this.editingRecord["key"]).update({
          "player2Kyu": kyu
        });
      }
    },
    getFiscalYear(unixtime) {
      let year = dayjs(unixtime * 1000).format("YYYY")
      let month = dayjs(unixtime * 1000).format("M")
      if (month < 4) return year - 1
      else return year
    }
  },
}
</script>
